import {
	ChangeDetectionStrategy,
	Component,
	computed,
	forwardRef,
	input,
	model,
} from '@angular/core';
import {
	ControlValueAccessor,
	FormsModule,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
	ClientSigningDetailsViewModelComplete,
	ParticipantTypeEnum,
} from '@models/e-signing';
import { AvatarComponent } from '@ui/avatar/avatar.component';
import { AVATAR_VARIANT } from '@ui/utils/constants';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import {
	ToggleComponent,
	TOGGLE_TYPES,
} from 'src/app/ui/toggle/toggle.component';

@Component({
	selector: 'app-e-signing-recipient-list-item',
	imports: [AvatarComponent, ToggleComponent, AtomicModule, FormsModule],
	templateUrl: './e-signing-recipient-list-item.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'w-full ' },
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ESigningRecipientListItemComponent),
			multi: true,
		},
	],
})
export class ESigningRecipientListItemComponent
	implements ControlValueAccessor
{
	onChange: (value: { email: string; isParticipating: boolean }) => void;
	onTouched: VoidFunction;

	writeValue(newValue: ClientSigningDetailsViewModelComplete): void {
		this.recipientValues.update((values) => ({
			...values,
			...newValue,
		}));
	}
	registerOnChange(
		fn: (email: { email: string; isParticipating: boolean }) => void,
	): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: VoidFunction): void {
		this.onTouched = fn;
	}

	recipientValues = model<{
		email: string;
		isParticipating: boolean;
		participantType: ParticipantTypeEnum;
	}>({
		email: '',
		isParticipating: false,
		participantType: ParticipantTypeEnum.CLIENT,
	});
	recipientId = input<string>('');
	recipientName = input<string>('');
	recipientInitials = input<string>('');
	avatarVariant = input<AVATAR_VARIANT>(AVATAR_VARIANT.Emerald);
	submitted_ = input<boolean>(false);
	buttonData = computed(() => ({
		ariaLabel: this.recipientValues().isParticipating
			? `Remove ${this.recipientName()} from participating recipients`
			: `Add ${this.recipientName()} to participating recipients`,
		icon: this.recipientValues().isParticipating ? 'minus' : 'plus',
	}));
	TOGGLE_TYPES = TOGGLE_TYPES;

	public updateIsRecipientParticipating() {
		this.recipientValues.update((values) => {
			const newUpdate = {
				...values,
				isParticipating: !values.isParticipating,
			};
			this.onChange(newUpdate);
			return newUpdate;
		});
	}

	public onEmailChange(email: string) {
		this.recipientValues.update((values) => {
			const newUpdate = {
				...values,
				email,
			};
			this.onChange(newUpdate);
			return newUpdate;
		});
	}
}
